export default __webpack_public_path__ + "static/media/user.d7255d5b.svg";